import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { useVModel, useDebounceFn } from '@vueuse/core';
import { ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { formSchemas, options } from '../config';
import permissionMenu from './PermissionMenu';
import { updateModuleConfig, saveConfig } from '@/api/authModule';
export default {
  __name: 'ModuleConfig',
  props: {
    // 是否回显数据
    model: {
      type: Object,
      default: null
    },
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:modelValue', 'refreshData', 'clearModel'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const originFormData = {};
    formSchemas.forEach(item => {
      // eslint-disable-next-line
      originFormData[item['field']] = item['defaultValue'];
    });

    // 表单数据
    const formData = ref(originFormData);
    watch(() => props.model, val => {
      if (val) {
        formData.value = props.model;
      }
    });
    const resetForm = () => {
      formData.value = originFormData;
    };
    const dataLoading = ref(false);
    const emits = __emit;
    const isVisible = useVModel(props);

    // 表单元素
    const formEl = ref(null);
    const menuArr = ref([]);
    const handleUpdatePermissionMenu = useDebounceFn(val => {
      if (!val || !val.length) menuArr.value = [];
      menuArr.value = val.map(item => ({
        menuId: item.id
      }));
    });

    /**
     * 新增事件
     */
    const loading = ref(false);
    const handleAddNewData = useDebounceFn(async () => {
      if (!formEl.value) return;
      await formEl.value.validate(async (valid, fields) => {
        if (valid) {
          loading.value = true;

          // 版本号
          try {
            if (!props.model) {
              // TODO 增加诊所保存
              await saveConfig({
                ...formData.value,
                hisAppMenus: menuArr.value
              });
            } else {
              await updateModuleConfig({
                ...formData.value,
                hisAppMenus: menuArr.value
              });
            }
            emits('refreshData');
            ElMessage({
              type: 'success',
              message: props.model ? '修改成功' : '添加成功'
            });
          } catch (error) {} finally {
            loading.value = false;
            isVisible.value = false;
          }
        }
      });
    }, 300);
    const closed = () => {
      formEl.value.resetFields();
      resetForm();
      if (props.model) {
        emits('clearModel');
      }
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(isVisible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(isVisible) ? isVisible.value = $event : null),
        title: __props.model ? '修改应用配置' : '新增应用配置',
        width: "60%",
        onClosed: closed,
        style: {
          "display": "flex",
          "flex-direction": "column"
        },
        "destroy-on-close": "",
        class: "dialog-class",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => isVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _unref(handleAddNewData),
          loading: loading.value
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        }, 8, ["onClick", "loading"])])]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_form, {
          "label-width": "150px",
          model: formData.value,
          style: {
            "max-width": "90%"
          },
          ref_key: "formEl",
          ref: formEl
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formSchemas), (item, index) => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: index
            }, [item.component === 'Input' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                placeholder: item.placeholder,
                maxlength: item.minlength || '',
                "show-word-limit": item.shoWordLimit
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "maxlength", "show-word-limit"])]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true), item.component === 'InputTextArea' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                placeholder: item.placeholder,
                type: "textarea",
                autosize: {
                  minRows: 3
                }
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true), item.component === 'InputNumber' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                min: 1
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true), item.component === 'Radio' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.radioArr, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_radio, {
                    key: index,
                    label: item.value,
                    border: ""
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                    _: 2
                  }, 1032, ["label"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true), item.component === 'Select' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 4,
              label: item.label,
              prop: item.field
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                placeholder: item.placeholder,
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [_createElementVNode("template", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 128))])]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])]),
              _: 2
            }, 1032, ["label", "prop"])) : _createCommentVNode("", true), item.component === 'SelectSearch' && __props.model ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 5,
              label: item.label,
              prop: item.field
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: __props.model.name,
                disabled: "",
                placeholder: "请输入关键字",
                style: {
                  "width": "400px",
                  "margin-bottom": "1rpx"
                }
              }, null, 8, ["modelValue"])]),
              _: 2
            }, 1032, ["label", "prop"])) : _createCommentVNode("", true)], 64);
          }), 128)), _createVNode(_component_el_form_item, {
            label: "菜单权限"
          }, {
            default: _withCtx(() => {
              var _props$model;
              return [_createVNode(_unref(permissionMenu), {
                configId: (_props$model = __props.model) === null || _props$model === void 0 ? void 0 : _props$model.id,
                onUpdate: _unref(handleUpdatePermissionMenu)
              }, null, 8, ["configId", "onUpdate"])];
            }),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])), [[_directive_loading, dataLoading.value]])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};